import './OtpInput.css'
import OtpField from '@corvu/otp-field'
import { createSignal, onCleanup, onMount, Show } from 'solid-js'
import { useSelector } from '../../store'
import { useConfig } from '../config/useConfig'
import { useSpatialNavigation } from '../../spatialNavigation'

interface IPinField {
  length: number
  onComplete: (value: string) => void
  onChange: () => void
}

export const OtpInput = (props: IPinField) => {
  const fakeArray = new Array(props.length).fill(0)

  const { getConfig } = useConfig()
  const { pause, resume } = useSpatialNavigation()

  const [inputRef, setInputRef] = createSignal<HTMLInputElement>()

  const locale = useSelector((state: { language: { locale: string } }) => state?.language?.locale)
  const isRtl = () => getConfig().rtlLanguages.includes(locale())

  const onValueChange = (value: string) => {
    if (value.length !== props.length) props.onChange()
  }

  onCleanup(() => {
    resume()
  })

  onMount(() => {
    pause()
    inputRef()?.focus?.()
  })

  return (
    <div class="pin_input_wrapper" style={{ direction: isRtl() ? 'rtl' : 'unset' }}>
      <OtpField maxLength={props.length} onComplete={props.onComplete} onValueChange={onValueChange} >
        <OtpField.Input ref={(ref) => setInputRef(ref)} />
        <div class="slot_wrapper">
          {fakeArray.map((value: number, index: number) => <Slot index={index} />)}
        </div>
      </OtpField>
    </div>
  )
}

const Slot = (props: { index: number }) => {
  const context = OtpField.useContext()
  const char = () => context.value()[props.index]
  const showFakeCaret = () =>
    context.value().length === props.index && context.isInserting()

  return (
    <div class={`slot ${context.activeSlots().includes(props.index) ? 'active_slot' : ''}`} >
      {char()}
      <Show when={showFakeCaret()}>
        <div class="fake_caret_wrapper">
          <div class="fake_caret" />
        </div>
      </Show>
    </div>
  )
}

export default OtpInput
